<template>
  <a-modal
    :visible="visible"
    :footer="null"
    :maskClosable="false"
    wrapClassName="retail-expired-barcode-modal"
    @cancel="$emit('close')"
  >
    <template #title>
      <div class="retail-expired-barcode-title">
        <span class="retail-expired-barcode-icon" aria-hidden="true">
          <i class="fas fa-exclamation-triangle"></i>
        </span>
        <strong>{{ $t('retailSale.search.expiredBarcodeTitle') }}</strong>
      </div>
    </template>
    <div class="retail-expired-barcode-message" role="alert">
      {{ $t('retailSale.search.expiredBarcode', { date: expiryDate }) }}
    </div>
    <div class="retail-expired-barcode-actions">
      <a-button type="primary" @click="$emit('close')">
        {{ $t('retailSale.search.expiredBarcodeOk') }}
      </a-button>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'RetailExpiredBarcodeModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    expiryDate: {
      type: String,
      default: ''
    }
  }
}
</script>

<style src="../../styles/retail-expired-barcode-modal.css"></style>
